import * as PropTypes from 'prop-types';
import React from 'react';

export const ButtonContainer = ({ style, smallMargin, left, children }) => {
  return (
    <div
      data-e2e="ctButtonContainer"
      className={`ct-button-container${smallMargin ? ' ct-button-container--small' : ''}${
        left ? ' ct-button-container--left' : ''
      }`}
      style={style}
    >
      {children}
    </div>
  );
};

ButtonContainer.propTypes = {
  smallMargin: PropTypes.bool,
  left: PropTypes.bool,
};
